// extracted by mini-css-extract-plugin
export default {"spinner":"UserMenu_spinner__eJg7o","signout-item":"UserMenu_signout-item__-RiDN","userMenu":"UserMenu_userMenu__8+hhz","menuItemText":"UserMenu_menuItemText__EIIOz"};